import { jsx } from 'react/jsx-runtime';
import { ConfirmDialog } from './ConfirmDialog.js';

/**
 * Reusable delete confirmation dialog for CRUD operations
 * Provides consistent delete confirmation experience across list and detail views
 */
function DeleteRecordDialog({ open, onOpenChange, entityName, loading, onConfirm, title, description, }) {
    return (jsx(ConfirmDialog, { open: open, onOpenChange: onOpenChange, title: title || `Delete ${entityName}`, description: description ||
            `Are you sure you want to delete this ${entityName.toLowerCase()}? This action cannot be undone.`, confirmText: "Delete", cancelText: "Cancel", variant: "destructive", loading: loading, onConfirm: onConfirm }));
}

export { DeleteRecordDialog };
//# sourceMappingURL=DeleteRecordDialog.js.map
